export default {"src":"/_next/static/media/picklesLogo.bb683628.svg","height":30,"width":114};